import { Box } from "@mui/material";

import Header from "../header";
import SideBar from "../sidebar";
import Loader from "../loader/loader";
import "./container.scss";
import usePrivateContainer from "./helper";
import NoInternetAlert from "../noInternetAlert";
import SocketImplementation from "../web-socket";
import { MainContainerProps } from "./container.type";
import { IMAGES } from "../../common/constants/images";
import { useAppSelector } from "../../hooks/useAppSelector";
import { RootState } from "../../redux/store";

const PrivateWrapper = ({
  children,
  isAuthenticator,
  moduleKey,
  path,
}: MainContainerProps) => {
  const { isOnline, isFetched } = usePrivateContainer({
    moduleKey,
    path,
  });

  const sidebarCollapsed = useAppSelector(
    (state: RootState) => state.globalcontent.sidebarCollapsed,
  );

  return (
    <Box className="main-container">
      {isAuthenticator ? "" : <Header />}
      <Box className="main-inner-container">
        {isAuthenticator ? "" : <SideBar />}
        <Box
          className={
            isAuthenticator
              ? "main-right-container-auth"
              : `main-right-container ${sidebarCollapsed ? "collapsed" : ""}`
          }
        >
          {isOnline ? (
            isFetched ? (
              children
            ) : (
              <Loader open={true} />
            )
          ) : (
            <NoInternetAlert
              title="Network Issue"
              heading="Unable to connect to the server."
              subText="Please check your internet connection and try again."
              imageSrc={IMAGES.ConnectionLost}
            />
          )}
        </Box>
      </Box>
      <SocketImplementation />
    </Box>
  );
};

export default PrivateWrapper;
